module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/joint-venture/jv-possession/jv-possession-grid/jv-possession-grid.component.css
// module id = ./src/app/landprocurement/joint-venture/jv-possession/jv-possession-grid/jv-possession-grid.component.css
// module chunks = main